import React from 'react';
import "./sectionRealtimeData.scss";

//Imagens:
import ImgRealtime from "../../../../assets/realtimeData/realtimeData.png"
import { useTranslation } from 'react-i18next';

function SectionRealtime() {
  const { t } = useTranslation()

  return (
    <div className='container-section-realtime'>
      <div className='texts-realtime'>
        <h1>{t("realtime_data.title")}</h1>
        <p>{t("realtime_data.section_text_1")}</p>
        <p>{t("realtime_data.section_text_2")}</p>
        <a href="/form" style={{ textDecoration: "none" }}><button id='btn-realtime-desktop'>{t("buttons.demo_btn_alternative_text_1")}</button></a>
      </div>
      <div className='img-realtime'>
        <img src={ImgRealtime} alt="" />
      </div>
      <div className='btn-realtime'>
        <button id='btn-realtime-mobile'>{t("buttons.demo_btn_alternative_text_1")}</button>
      </div>
    </div>
  )
}

export default SectionRealtime;